import React, { useEffect, useState } from 'react';
import StickySidebar from 'components/shared/StickySidebar';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { formattedDateTime } from '../__helpers__/journeyHelper';

const InformationSidebar = () => {
  const {
    creator,
    createdAt,
    lastUpdater,
    updatedAt,
    lastPublisher,
    lastPublishedAt,
    published,
  } = useSelector(state => {
    return state;
  });

  const [updater, setUpdater] = useState(lastUpdater);

  useEffect(() => {
    setUpdater(lastUpdater);
  }, [lastUpdater]);

  const [formattedUpdatedDate, setFormattedUpdatedDate] = useState(
    formattedDateTime(updatedAt),
  );
  const [formatLastPublishedAt, setFormatLastPublishedAt] =
    useState(lastPublishedAt);

  useEffect(() => {
    if (lastPublishedAt) {
      setFormatLastPublishedAt(formattedDateTime(lastPublishedAt));
    }

    if (published) {
      setFormattedUpdatedDate(formattedDateTime(updatedAt));
    }
  }, [lastPublishedAt, published, updatedAt]);

  const JourneyBuilderInformationSidebarCardClassName = classNames(
    'JourneyBuilderInformationSidebarCard',
    {
      JourneyBuilderInformationSidebarCard: !published,
      'JourneyBuilderInformationSidebarCard-extend': published,
    },
  );
  return (
    <StickySidebar className="JourneyBuilderInformationSidebar">
      <div className={JourneyBuilderInformationSidebarCardClassName}>
        <div className="JourneyBuilderInformationSidebarCard-header">
          <p>{t('journeys.builder.details')}</p>
        </div>
        <div className="JourneyBuilderInformationSidebarCard-created">
          <p className="JourneyBuilderInformationSidebarCard-info-title">
            {t('journeys.builder.created')}
          </p>
          <p className="JourneyBuilderInformationSidebarCard-info">
            {formattedDateTime(createdAt)}
            {creator &&
              `${' '}${t('journeys.builder.by', {
                name: creator,
              })}`}
          </p>
          <p className="JourneyBuilderInformationSidebarCard-info-title">
            {t('journeys.builder.last_updated')}
          </p>
          <p className="JourneyBuilderInformationSidebarCard-info">
            {formattedUpdatedDate}
            {updater &&
              `${' '}${t('journeys.builder.by', {
                name: updater,
              })}`}
          </p>
          {published && (
            <>
              <p className="JourneyBuilderInformationSidebarCard-info-title">
                {t('journeys.builder.published')}
              </p>
              <p className="JourneyBuilderInformationSidebarCard-info">
                {formatLastPublishedAt}
                {lastPublisher &&
                  `${' '}${t('journeys.builder.by', {
                    name: lastPublisher,
                  })}`}
              </p>
            </>
          )}
        </div>
      </div>
    </StickySidebar>
  );
};

export default InformationSidebar;
